module.exports = __webpack_public_path__ + "fonts/Bagnard-2.0bf57526.otf";